module.exports = __webpack_public_path__ + "static/media/ruler.09c3ed09.svg";